/** True when a useAPI slice has finished successfully (2xx, no error, not in flight). */
export function isApiSliceSaveSuccess(state, sliceKey) {
  var slice = state.api[sliceKey];
  if (!slice || slice.requesting) return false;
  if (slice.error) return false;
  return slice.statusCode !== undefined && slice.statusCode >= 200 && slice.statusCode < 300;
}